<template>
  <div class="sidebar-logo-container" :class="{'collapse': collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <span class="logo-icon">⛰</span>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <span class="logo-icon">⛰</span>
        <div class="logo-text">
          <span class="logo-title">挑战十峰</span>
          <span class="logo-sub">Admin</span>
        </div>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: { type: Boolean, required: true }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active { transition: opacity 0.3s; }
.sidebarLogoFade-enter, .sidebarLogoFade-leave-to { opacity: 0; }

.sidebar-logo-container {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #0A1A14 0%, #0F2027 100%);
  border-bottom: 1px solid rgba(116,198,157,0.15);
  overflow: hidden;

  .sidebar-logo-link {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    padding: 0 16px;
    width: 100%;
  }

  .logo-icon {
    font-size: 26px;
    flex-shrink: 0;
    filter: drop-shadow(0 2px 8px rgba(116,198,157,0.6));
  }

  .logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }

  .logo-title {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 2px;
  }

  .logo-sub {
    font-size: 11px;
    color: #74C69D;
    letter-spacing: 3px;
    margin-top: 1px;
  }

  &.collapse {
    .sidebar-logo-link { justify-content: center; padding: 0; }
    .logo-icon { font-size: 22px; }
  }
}
</style>
